import React, {useEffect, useState} from 'react';
import {Form, Header, Segment, Table} from 'semantic-ui-react';
import {useLoaderData, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {useBlockUI} from 'shared/services/block-ui-service';
import {ToasterConfig} from "../../../../config/ToasterConfig";
import {ShortDto} from "../../../../models/short-dto";
import useBusinessUnitService from "../../../../services/backoffice/hooks/useBusinessUnitService";
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import useFleetService from "../../../../services/backoffice/hooks/useFleetService";
import {UpdateFleetRequest} from "../../../../models/requests/update-fleet-request";

export async function editFleetLoader({params}: any) {
    return params.id;
}

const EditFleetPage = () => {
    const [fleet, setFleet] = useState<Partial<UpdateFleetRequest>>();
    const [loading, setLoading] = useState<boolean>(false);
    const [clientes, setClients] = useState<ShortDto[]>([])
    const [businessUnits, setBusinessUnits] = useState<ShortDto[]>([])
    const [error, setError] = useState<string>('');
    const navigate = useNavigate();
    const loader: any = useLoaderData();
    const {getAllGetUnitsShortDto} = useBusinessUnitService();
    const {getAllClientsShortDto} = useClientService();
    const {editFleet, getFleetById} = useFleetService();
    const blockUI = useBlockUI();
    const [clientId, setClientId] = useState<string>('');

    useEffect(() => {
        const fleetId = loader;
        if (!fleetId) return;
        getFleetById(fleetId).then((response: any) => {
            setFleet(response)
        })
    }, [loader])


    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);


    useEffect(() => {
        function ListClientes() {
            getAllClientsShortDto().then((response) => {
                setClients(response);
            })
                .catch(error => {
                })
        };

        ListClientes()
    }, [])

    useEffect(() => {
        getAllGetUnitsShortDto({clientId})
            .then(response => setBusinessUnits(response))
            .catch(error => console.error('Erro ao carregar unidades de negócio:', error));
    }, [fleet?.clientId]);


    const updateFleet = async () => {
        try {
            setLoading(true);
            if (fleet) {
                const result = await editFleet(fleet, fleet.id)
                    .finally(() => setLoading(false));
                if (!!result) navigate('/backoffice/fleets/')
                toast.success('Operação atualizado com sucesso', ToasterConfig.success);
            }
        } catch (error: any) {
            setLoading(false);
            setError(error.message);
        }
    };

    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Operação / Editar
            </Header>
            <Form size="large" onSubmit={updateFleet}>
                <Segment stacked>


                    <Form.Input
                        fluid
                        label="Nome"
                        placeholder="Nome da Operação"
                        name="name"
                        value={fleet?.operationName}
                        onChange={(event) => setFleet({...fleet, operationName: event.target.value})}
                    />


                    <Form.Select
                        label={'Cliente ao qual a Operação pertence'}
                        options={clientes}
                        placeholder='Selecione uma opção'
                        value={fleet?.clientId || ''}
                        required
                        search
                        clearable
                        onChange={(e: any, data: any) => {
                            const selectedValue = data.value;
                            setClientId(selectedValue);
                            setFleet(prevUnit => ({...prevUnit, clientId: selectedValue}));
                        }}
                    />

                    <Form.Select
                        label={'Unidade de Negócio da Operação'}
                        options={businessUnits}
                        placeholder='Selecione uma opção'
                        value={fleet?.businessUnitId || ''}
                        required
                        search
                        clearable
                        onChange={(e: any, data: any) => {
                            const selectedValue = data.value;
                            setFleet(prevUnit => ({...prevUnit, businessUnitId: selectedValue}));
                        }}
                        disabled={!fleet?.clientId}

                    />

                    <Table.Row>
                        <Table.HeaderCell>
                            <Form.Button content="Voltar"
                                         icon='arrow left'
                                         onClick={() => navigate('/backoffice/fleets/')} grey/>
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            <Form.Button content="Atualizar"
                                         type={"submit"}
                                         icon='save'
                                         color={"green"}/>
                        </Table.HeaderCell>
                    </Table.Row>
                </Segment>
            </Form>
        </div>
    );
};

export default EditFleetPage;
